export default class CartFullLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = 'popup_cart_full';

    this.setEvent();
    this.render();
  }

  setEvent = () => {
    this.welContainer.on(
      'click',
      `.${this.sWrapper} .popup_button.type01`,
      this.openCart
    );
    this.welContainer.on(
      'click',
      `.${this.sWrapper} .popup_button.type02`,
      this.onClose
    );
  };

  openCart = e => {
    e.preventDefault();
    TMON.oApp.oViews.closeLayer();
    if (TMON.view_mode === 'app') {
      TMON.app.callApp('webview', 'goCart');
    } else {
      location.href = TMON.htLocal.htURL.www_cart;
    }
  }

  onClose = e => {
    e.preventDefault();
    TMON.oApp.oViews.closeLayer();
  };

  render = () => {
    const sHtml = 
      `<section class="popup popup_layer popup_cart_full">  
        <header class="popup_header">
          <h3 class="popup_header_title">
          ${TMON.sDevice === 'PW' ? 
            '장바구니에 담을 수 있는 상품 수는 최대 100개 입니다.<br>장바구니를 확인해주세요'
            : '장바구니에 담을 수 있는 최대 상품 수는<br>최대 100개 입니다.<br>장바구니를 확인해주세요'
          }
          </h3>
        </header>
        <div class="popup_contents">
          <div class="popup_buttons">
            <button type="button" class="popup_button type02">
            닫기
            </button>
            <button type="button" class="popup_button type01">
            장바구니 바로가기
            </button>
         </div>
        </div>
      </section>`;
    this.welContainer.append(sHtml);
  };

  open = () => {
    TMON.oApp.oUtil.handleOpenLayer({
      welTargetLayer: $(`.${this.sWrapper}`),
      bSetHash: false,
      bUseHistorybackOnClose: false,
      bShowDimmed: false,
    });
  };
}
